import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, setToken, getVenueToken, setVenueToken } from '@/utils/auth'
import * as uniWebView from '@/utils/uni_webview'

Vue.use(VueRouter)

const routes = [
  {
    path: '/detail/performance',
    name: 'performance',
    meta: {
      title: '演出活动详情页',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/performance.vue'),
  },
  {
    path: '/detail/PerformanceVideo',
    name: 'PerformanceVideo',
    meta: {
      title: '演出视频详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/PerformanceVideo.vue'),
  },
  {
    path: '/detail/activityRegistration',
    name: 'activityRegistration',
    meta: {
      title: '活动报名',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/activityRegistration.vue'),
  },
  {
    path: '/detail/registrationResult',
    name: 'registrationResult',
    meta: {
      title: '活动报名',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/registrationResult.vue'),
  },
  {
    path: '/detail/culturalCollection',
    name: 'culturalCollection',
    meta: {
      title: '藏品详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/culturalCollection.vue'),
  },
  {
    path: '/detail/venueVenue',
    name: 'venueVenue',
    meta: {
      title: '场馆详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/venueVenue.vue'),
  },
  {
    path: '/detail/venueSite',
    name: 'venueSite',
    meta: {
      title: '场地详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/venueSite.vue'),
  },
  {
    path: '/detail/venueReservation',
    name: 'venueReservation',
    meta: {
      title: '场地预定详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/venueReservation.vue'),
  },
  {
    path: '/detail/onlineExhibition',
    name: 'onlineExhibition',
    meta: {
      title: '线上展览详情',
      sign: 'H5',
      keepAlive: true,
    },
    component: () => import('@/views/allDetail/onlineExhibition.vue'),
  },
  {
    path: '/detail/exhibitionDetail',
    name: 'exhibitionDetail',
    meta: {
      title: '线上展览展示详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/exhibitionDetail.vue'),
  },
  {
    path: '/detail/messageDetail',
    name: 'messageDetail',
    meta: {
      title: '资讯详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/messageDetail.vue'),
  },
  {
    path: '/detail/extrageneticDirectories',
    name: 'extrageneticDirectories',
    meta: {
      title: '非遗名录详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/extrageneticDirectories.vue'),
  },
  {
    path: '/detail/inheritor',
    name: 'inheritor',
    meta: {
      title: '传承人详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/inheritor.vue'),
  },
  {
    path: '/detail/liveStreaming',
    name: 'liveStreaming',
    meta: {
      title: '直播详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/liveStreaming.vue'),
  },
  {
    path: '/detail/onlineTraining',
    name: 'onlineTraining',
    meta: {
      title: '线上培训详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/onlineTraining.vue'),
  },
  {
    path: '/detail/offlineTraining',
    name: 'offlineTraining',
    meta: {
      title: '线下培训详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/offlineTraining.vue'),
  },
  {
    path: '/detail/eBook',
    name: 'eBook',
    meta: {
      title: '图书详情',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/allDetail/eBook.vue'),
  },
  {
    path: '/reservation/reservation',
    name: 'reservation',
    meta: {
      title: '预约',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/reservation/reservation.vue'),
  },
  {
    path: '/reservation/reservationSite',
    name: 'reservationSite',
    meta: {
      title: '预约',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/reservation/reservationSite.vue'),
  },
  {
    path: '/reservation/tips',
    name: 'reservation',
    meta: {
      title: '预约结果',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/reservation/tips.vue'),
  },
  {
    path: '/reservation/audit',
    name: 'audit',
    meta: {
      title: '审核中',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/reservation/audit.vue'),
  },
  {
    path: '/reservation/rule',
    name: 'rule',
    meta: {
      title: '预约须知',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/reservation/rule.vue'),
  },
  {
    path: '*',
    name: 'NotDefined',
    meta: {
      title: '页面找不到',
      sign: 'H5',
      keepAlive: false,
    },
    component: () => import('@/views/Public/NotDefined.vue'),
  },
  {
    path: '/share/performance',
    name: 'performance',
    meta: {
      title: '活动分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/performance.vue'),
  },
  {
    path: '/share/PerformanceVideo',
    name: 'PerformanceVideo',
    meta: {
      title: '视频分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/PerformanceVideo.vue'),
  },
  {
    path: '/share/onlineTraining',
    name: 'onlineTraining',
    meta: {
      title: '线上培训分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/onlineTraining.vue'),
  },
  {
    path: '/share/offlineTraining',
    name: 'offlineTraining',
    meta: {
      title: '线下培训分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/offlineTraining.vue'),
  },
  {
    path: '/share/liveStreaming',
    name: 'liveStreaming',
    meta: {
      title: '直播详情分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/liveStreaming.vue'),
  },
  {
    path: '/share/venueVenue',
    name: 'venueVenue',
    meta: {
      title: '场馆详情分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/venueVenue.vue'),
  },
  {
    path: '/share/venueSite',
    name: 'venueSite',
    meta: {
      title: '场地详情分享页',
      sign: 'share',
      keepAlive: false,
    },
    component: () => import('@/views/share/venueSite.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, form, next) => {
  if (to.query.params) {
    const { token, venueToken } = JSON.parse(to.query.params)
    setToken(token)
    setVenueToken(venueToken)
  }

  // if (!form.name) {
  //   console.log('从app来的')
  //   if (to.query.params) {
  //     const { token, venueToken } = JSON.parse(to.query.params)
  //     if (token) {
  //       setToken(token)
  //     }
  //     if (!getToken() && !token) {
  //       uniWebView.reLaunch({
  //         url: '/pages/login/index',
  //       })
  //       return
  //     }
  //     if (!getToken() && token) {
  //       setToken(token)
  //       next()
  //     }
  //     if (to.path === '/detail/venueVenue') {
  //       if (venueToken) {
  //         setVenueToken(venueToken)
  //       }
  //       // console.log('是否需要token')
  //       if (venueToken && !getVenueToken()) {
  //         setVenueToken(venueToken)
  //         next()
  //       }
  //     }
  //   }
  // }
  next()

  // if (to.path === '/login' || to.path === '/policyDetail') return next()
  // // token
  // const tokenStr = getToken()
  // if (!tokenStr) return next('/login')

  // const { title, backgroundColor } = to.meta
  // // 修改文档信息
  // document.title = title || '浙里课后服务'
  // // document.title = "浙里课后服务";
  // document.querySelector('body').setAttribute('style', 'background-color:' + backgroundColor || '#ffffff')
  // // 页面回到顶部
  // document.documentElement.scrollTop = 0
  // // next: Function 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
})

export default router
